export default __webpack_public_path__ + "static/media/henanluanchuan.d9243039.png";